import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getPerformance } from 'firebase/performance';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAWWSxczhJ-nitO0rwqV2WWrctsV6t4R18",
    authDomain: "quantified-world.firebaseapp.com",
    projectId: "quantified-world",
    storageBucket: "quantified-world.firebasestorage.app",
    messagingSenderId: "699315859566",
    appId: "1:699315859566:web:882af942910478718b367f",
    measurementId: "G-5YR21EJJ2C"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Initialize Analytics and Performance conditionally (to avoid errors in environments without window/analytics support)
export let analytics = null;
export let perf = null;

isSupported().then((supported) => {
    if (supported) {
        analytics = getAnalytics(app);
        perf = getPerformance(app);
        console.log('Firebase Analytics & Performance initialized');
    }
});

export default app;
